import React from "react";
import { useRecoilValue } from "recoil";
import { Switch, Route } from "@components/router";
import state, { EPages } from "./state";
import OperationsOverview from "./OperationsOverview";
import ProductionSetup from "./ProductionSetup";

const RouteBusiness = () => {
  const page = useRecoilValue(state);

  return (
    <Switch value={page}>
      <Route
        routeValue={EPages.OPERATIONS_OVERVIEW}
        Component={OperationsOverview}
      />
      <Route routeValue={EPages.PRODUCTION_SETUP} Component={ProductionSetup} />
    </Switch>
  );
};

export default RouteBusiness;
